import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * AdminDomainGuard - Ensures admin routes are only accessible from allowed domains
 * 
 * Allowed domains for admin access:
 * - admin.nammahut.com
 * - nammahut.com (main domain - admin at /admin path)
 * - localhost (for development)
 * - *.preview.emergentagent.com (for preview/testing)
 */
const AdminDomainGuard = ({ children }) => {
  const hostname = window.location.hostname;
  
  // Check if accessing from allowed admin domains
  const isAdminDomain = 
    hostname.startsWith('admin.') ||           // admin.nammahut.com subdomain
    hostname === 'nammahut.com' ||             // Main domain (admin via /admin path)
    hostname === 'www.nammahut.com' ||         // WWW domain
    hostname === 'localhost' ||                // Local development
    hostname.includes('preview.emergentagent.com') || // Emergent preview URLs
    hostname.includes('emergentagent.com');    // Any Emergent domain
  
  // If not on allowed domain, redirect to homepage
  if (!isAdminDomain) {
    console.warn('Admin access blocked: Not on allowed domain');
    return <Navigate to="/" replace />;
  }
  
  return children;
};

export default AdminDomainGuard;
